import { useCallback } from 'react';
import useCustomizeCarContext from '../useCustomizeCarContext';

const useStockCar = () => {
  const { selectedCar } = useCustomizeCarContext();

  const getStockCarByCarId = useCallback(
    (carId: string) => {
      const { similarStockCars } = selectedCar || {};

      return similarStockCars.filter(stock => stock.carId === carId);
    },
    [selectedCar],
  );

  return { getStockCarByCarId };
};

export default useStockCar;
